module.exports = __webpack_public_path__ + "media/images/simple_monocromo-5f569288b7c57fe25e9e53674081506a.svg";